<template>
  <div :class="['unread-messages-icon', classes]" v-if="unreadNumber">
    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-light opacity-75"></span>
    <p>{{ unreadNumber }}</p>
  </div>
</template>

<script>
  export default {
    name: 'UnreadMessages',

    props: {
      unread: {
        type: [Number,String],
        default: 0
      },
      classes: {
        type: String
      }
    },

    data() {
      return {
        nomessages: false
      }
    },

    mounted() {
      console.log('UnreadMessages:', typeof this.unread, this.unread, this.classes);
    },

    methods: {

    },

    computed: {
      unreadNumber() {
        let unreadMmessages = parseInt(this.unread) === 0 ? false : parseInt(this.unread) > 9 ? '9+' : this.unread;
        return unreadMmessages;
      }
    }
  };
</script>